// extracted by mini-css-extract-plugin
module.exports = {"button":"_25d45facb5--button--pv5jF","dark":"_25d45facb5--dark--SHfpm"};